import { render, staticRenderFns } from "./DocTypeTree.vue?vue&type=template&id=60a76e44&scoped=true&"
import script from "./DocTypeTree.vue?vue&type=script&lang=js&"
export * from "./DocTypeTree.vue?vue&type=script&lang=js&"
import style0 from "./DocTypeTree.vue?vue&type=style&index=0&id=60a76e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a76e44",
  null
  
)

export default component.exports